
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/webinar",
      function () {
        return require("private-next-pages/egypt/webinar.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/webinar"])
      });
    }
  